export const getters = {
  getResults: (state) => {
    if (state.results.length == 0) return [];
    return state.results;
  },
  getPaging: (state) => {
    return {
      ...state.paging,
      totalRecords: state.paging.totalItemCount,
      totalPages: state.paging.pageCount,
      pageSize: state.configPaginated.pageSize,
    };
  },
  getCurrentFilters: (state) => {
    return state.model;
  },
};
